import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './style.css'
import '@mdi/font/css/materialdesignicons.css'
import { applyApexTheme } from './lib/apexTheme.js'

applyApexTheme()

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app') 